export function education() {
  const containers = document.querySelectorAll(".education-2025__list");

  function init() {
    const narrow = window.innerWidth < 1240;

    containers.forEach((e, i) => {
      const elems = e.querySelectorAll(".education-2025__elem");

      elems.forEach((elem, index) => {
        const card = elem.querySelector(".education-2025-card");
        const image = card.querySelector(".education-2025-card__image");

        if (
          !elem.classList.contains("education-2025__elem--static") &&
          elems.length > 1
        ) {
          if (elem.classList.contains("education-2025__elem--full")) {
            elem.classList.remove("education-2025__elem--full");
            elem.children[0].classList.remove("education-2025-card--full");
          }

          const shouldBeFull = index % 3 === 0;
          if (narrow && shouldBeFull) {
            elem.classList.add("education-2025__elem--full");
            card.classList.add("education-2025-card--full");
          } else if (!narrow && index == 0) {
            elem.classList.add("education-2025__elem--full");
            card.classList.add("education-2025-card--full");
          }

          if (
            image &&
            !card.classList.contains("education-2025-card--full") &&
            !card.classList.contains("education-2025-card--disabled-img")
          ) {
            card.classList.add("education-2025-card--img");
          } else {
            card.classList.remove("education-2025-card--img");
          }

          if (
            image &&
            narrow &&
            card.classList.contains("education-2025-card--disabled-img")
          ) {
            card.classList.add("education-2025-card--img-mobile");
          } else {
            card.classList.remove("education-2025-card--img-mobile");
          }
        }
      });
    });
  }

  window.addEventListener("resize", init);
  init();
}
